
				var addMethods = require("../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["getPayDates","getCurrentAmount"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "767a3ec48adcc3a843f0.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "767a3ec48adcc3a843f0.worker.js");
					addMethods(w, methods)
					
					return w
				}
			